module.exports = __webpack_public_path__ + "img/logo.9ca9378c.png";